<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{title}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>

 
      <div class="ttmodal__body">


          <mat-form-field class="input">
            <input matInput [min]="lastUpdateTime" [max] = "maxDate" readonly [matDatepicker]="myDatepicker" placeholderout="Date of Reading" [(ngModel)]="dateOfReading" >
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="input">
            <input matInput placeholder="SMU"  type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="smu"  (focusout)="CheckSMU()"
               required>
          </mat-form-field>
    
      
      </div>
      <div>
        <span *ngIf="SMUValidation" style="color:red;">SMU need to be greater than {{smuPrechange}}</span>

      </div>
      <div class="ttmodal__footer">
        <button mat-raised-button (click)="onNoClick()">{{'Cancel'}}</button>
        <button mat-raised-button color="warn" [class.loading]="saving" (click)="CreateNewInspection()" [disabled]= "Error_">
          <span class="button__text">{{'Create Inspection'}}</span>
        </button>
      </div>





  
</div>